/* istanbul ignore file */
import { useFieldHelper, FieldProps } from 'framework/ui/field';
import { CustomBadge } from 'framework/ui/ui-builder';
import {
  CandidateApplicationStatus,
  CandidateApplicationStatusOptions,
} from 'domain/recruiting/candidate/applications/shared/candidateApplicationService';

const CandidateApplicationStatusBadge = ({ value: inputValue, source, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });

  const value = inputValue || getValue();

  const getColor = () => {
    return value === CandidateApplicationStatus.IN_PROCESSING ? 'success' : 'default';
  };

  return <CustomBadge text={CandidateApplicationStatusOptions[value]} color={getColor()} {...props} />;
};

export default CandidateApplicationStatusBadge;
